import { render } from "./oagent.vue?vue&type=template&id=766c37be&scoped=true"
const script = {}

import "./oagent.vue?vue&type=style&index=0&id=766c37be&lang=scss&scoped=true"

import exportComponent from "D:\\wwwroot\\mld\\vue-source\\mileIsland\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-766c37be"]])

export default __exports__